
document.addEventListener('DOMContentLoaded', function() {
  const DESCUENTO_PCT = 15;

  function formatMoney(cents) {
    return '$ ' + Math.round(cents).toLocaleString('es-CL');
  }

function updateTransferPrice(price) {
  const ahorro = Math.round(price * DESCUENTO_PCT / 100);
  const precioTransferencia = price - ahorro;

  document.querySelectorAll('.product-price-transferencia__amount').forEach(function(el) {
    el.textContent = '$ ' + Math.round(precioTransferencia).toLocaleString('es-CL');
  });

  document.querySelectorAll('.product-price-transferencia__savings').forEach(function(el) {
    el.textContent = 'Ahorra $ ' + Math.round(ahorro).toLocaleString('es-CL') + ' (' + DESCUENTO_PCT + '% Dcto)';
  });
}

  // Escuchar cambio en el dropdown de variantes (escritorio)
  document.querySelectorAll('select[name="id[]"], select[name="id"]').forEach(function(el) {
    el.addEventListener('change', function() {
      const variantId = this.value;
      fetch('/products/' + window.location.pathname.split('/products/')[1].split('?')[0] + '.js')
        .then(r => r.json())
        .then(product => {
          const variant = product.variants.find(v => v.id == variantId);
          if (variant) updateTransferPrice(variant.price / 100);
        });
    });
  });

  // Respaldo: MutationObserver para móvil
  const priceContainer = document.querySelector('[data-product-price]');
  if (priceContainer) {
    new MutationObserver(function() {
      const priceEl = document.querySelector('[data-product-price] .money');
      if (priceEl) {
        const priceText = priceEl.textContent.replace(/[^0-9]/g, '');
        if (priceText) updateTransferPrice(parseInt(priceText));
      }
    }).observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }
});